import React, { useEffect, useState }from 'react';
import axios from 'axios';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import logo from "../Assets/default_author.png"

const TestimonialBody = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}testimonials/showtestimonials`);
        setTestimonials(response.data);
      } catch (error) {
        console.error('Error fetching testimonials:', error);
      }
    };
    
    fetchTestimonials();
  }, []);


  return (
    <div className="testimonial-area py-5 bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mx-auto text-center">
            <span className="text-muted">Testimonials</span>
            <h2 className="mt-2">What Our Clients Say</h2>
            <p className="lead">We Collect Reviews From Our Users So You Can Get An Honest Opinion</p>
          </div>
        </div>

        {testimonials.length > 0 ? (
          <OwlCarousel
            className="owl-carousel owl-theme"
            loop
            margin={15}
            nav={false}
            dots={true}
            autoplay={true}
            autoplayTimeout={3000}
            items={3}
            responsive={{
              0: { items: 1 },
              768: { items: 2 },
              992: { items: 3 }
            }}
          >
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-item">
                <div className="testimonial-rate">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="fas fa-star"></i>
                  ))}
                </div>
                <div className="testimonial-quote">
                  <p>{testimonial.testimonial_text}</p>
                </div>
                <div className="d-flex align-items-center">
                  <div className="testimonial-author-img me-3">
                    <img
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"
                      src={testimonial.author_image ? `${process.env.REACT_APP_API_URL}${testimonial.author_image}` : logo}
                      alt=""
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = logo;
                      }}
                    />
                  </div>
                  <div className="testimonial-author-info">
                    <h5 className="mb-1 fs-6">{testimonial.author_name}</h5>
                    <p className="mb-0 text-muted small">{testimonial.author_designation}</p>
                  </div>
                </div>
                <span className="testimonial-quote-icon">
                  <i className="flaticon-quote-1"></i>
                </span>
              </div>
            ))}
          </OwlCarousel>
        ) : (
          <p className="text-center">No testimonials available.</p>
        )}
      </div>
    </div>
  );
};
export default TestimonialBody;
